import React, { PropsWithChildren } from 'react';
import { useDroppableHeaderContext } from '../droppableHeaderV2.hook';
import MoveGlyph from '../../../../assets/icons/Glyph/MoveGlyph';

type DroppableHeaderActionsSlotContainerProps = PropsWithChildren<{
  isDraggable?: boolean;
}>;

export function DroppableHeaderActionsSlotContainer({ children, isDraggable }: DroppableHeaderActionsSlotContainerProps) {
  const { textColor, glyphColor } = useDroppableHeaderContext();
  return (
    <div className='actions-slot-container'>
      {children}
      {isDraggable && (
        <>
          <span className={`${textColor}`}>MOVE</span>
          <MoveGlyph color={glyphColor} />
        </>
      )}
    </div>
  );
}
